import React from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import Dashboard from './Components/Dashboard';
import LoginPage from './Components/LoginPage';
import './App.css';

const App = () => {
  return (
    <AuthProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard section="overview" />} />
            <Route path="/dashboard/charging" element={<Dashboard section="charging" />} />
            <Route path="/dashboard/statistics" element={<Dashboard section="statistics" />} />
            <Route path="/dashboard/maintenance" element={<Dashboard section="maintenance" />} />
            <Route path="/dashboard/settings" element={<Dashboard section="settings" />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </HashRouter>
    </AuthProvider>
  );
};

export default App;
